import React, {
  useState,
  useEffect,
} from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";

import { Box, Button, Dialog, Link } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { empty_uuid } from "./Account_urls.jsx";

import { GridScenarioViewPort } from "../Pages/GridScenario.jsx";
import Sweep from "./Sweep.jsx";

import SignIn from "../Pages/SignIn.jsx";
import TopNav from "./Navbar_bs.jsx";

import { useAuth, AuthProvider } from "./useAuth.jsx";
import ClientSelect from "../Pages/ClientSelect.jsx";
import SetupAccounts from "../Pages/SetupAccounts.jsx";
import ScenarioSelect from "../Pages/scenarioSelect.jsx";
import ScenarioCharts from "./ScenarioCharts.jsx";
import SubscriberSelect from "../Pages/SubscriberSelect.jsx";
import SetupSavingRules from "../Pages/SetupSavingRules.jsx";
import ProfileInput from "./ProfileInput.jsx";

import { ClientProvider } from "./useClient.jsx";
import { HelpProvider } from "../Dialogs/Help/useHelp.jsx"
import { useIdleTimeout } from "./useIdleTimeout.jsx";



import { Help_selectClient } from "../Dialogs/Help/Help_Select.jsx";
import { Starter } from "../Dialogs/Starter/StartWindow.jsx";
import { GoogleAnalyticsInitialize } from "../Components/ga4.jsx";
import { MSClarityInitialize } from "../Components/clarity.jsx";


import SuggestionBoard from "../Pages/SuggestionBoard.jsx";
import NewsBoard from "../Pages/NewsBoard.jsx";
import { Provider, ErrorBoundary, LEVEL_WARN } from '@rollbar/react' // Provider imports 'rollbar'
import { isDev } from "../Components/Environment.jsx";
import { CollapseVertical } from "./CollapseButtons.jsx";


import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "./App.scss";
import { creditsRemainingColor, myOwnFPColor } from "./GridRenderers.jsx";


const rollbarConfig = {
  accessToken: '07d466bf458243c0a0724e6c44f396ba',
  environment: isDev() ? 'localhost' : 'production',
  autoInstrument: {
    // network: true,
    log: false,
    // dom: true,
    // navigation: true,
    // connectivity: true,
    // contentSecurityPolicy: true,
    // errorOnContentSecurityPolicy: false
  }
}







const { palette } = createTheme();
const { augmentColor } = palette;
const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
// // const theme = createTheme({
//   palette: {
//     anger: createColor('#F40B27'),
//     apple: createColor('#5DBA40'),
//     steelBlue: createColor('#5C76B7'),
//     violet: createColor('#BC00A3'),
//   },
// });



///https://htmlcolorcodes.com/colors/shades-of-yellow/

let theme = createTheme({
  shape: {
    pillRadius: 50,
  },
  spacing: 4,
  size: "small",
  dense: true,
  palette: {
    primary: createColor(myOwnFPColor),
    black: createColor('#000000'),
    grey: createColor('#dddddd'),
    red: createColor('#ff0000'),
    yellow: createColor('#e2e200'),
    green: createColor('#00ff00'),
    helpgreen: createColor('#17be34'),
    ideayellow: createColor('#e2e200'),
    bookbrown: createColor('#9f8315'),
    softred: createColor('#C41E3A'), // cardinal
    softyellow: createColor('#fcf55f'), // icterine
    purple: createColor('#ce93d8'), // mui secondary 
    purpledark: createColor('#ab47bc'), // mui secondary dark
    white: createColor('#ffffff'),
    creditsRemaining: createColor(creditsRemainingColor),
    myOwnFP: createColor(myOwnFPColor),



  },
});

const AuthLayout = () => {
  return (
    <div className="App">
      <AuthProvider>
        <ClientProvider>
          <HelpProvider>
            <Outlet />
          </HelpProvider>
        </ClientProvider>
      </AuthProvider>
    </div>
  );
};


GoogleAnalyticsInitialize()
MSClarityInitialize()



const ProtectedLayout = () => {
  const { subscriber_r } = useAuth();
  const [idleOpen, setIdleOpen] = useState(false)

  const onIdlePrompt = () => {
    setIdleOpen(true)
  }
  const onIdleActive = () => {
    setIdleOpen(false)
  }
  const onStillThere = () => {
    setIdleOpen(false)
    activate()
  }

  const { isIdle, activate } = useIdleTimeout({
    onIdlePrompt: onIdlePrompt,
    onActive: onIdleActive,
    idleTime: 3600,
    promptBeforeIdle: 60,
  })

  console.log("Protect Layout SUB (R): " + subscriber_r.current);
  if (!subscriber_r.current) {
    return <Navigate to="/signin" />;
  }

  return (<div className="App">
    <Dialog open={idleOpen}>
      <Button variant="contained" onClick={onStillThere}>
        Are you there?
      </Button>
    </Dialog >
    {<Outlet />}
  </div>);
};

const TopLayout = ({ clientJson, c_callback }) => {
  const { startupHelp_, startupHelp_r } = useAuth();
  const [showStarter, setShowStarter] = useState(startupHelp_r.current)
  //console.log(startupHelp_r.current)

  const starterWidth = 400;
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TopNav clientJson={clientJson} c_callback={c_callback} />
        {/* <Sidenav /> */}
        {/* <Rightnav /> */}


        <div className="main">
          <Box sx={{ display: 'flex' }} >
            <Box
              sx={{
                flexGrow: 1,
                marginRight: showStarter ? 0 : -starterWidth / 4,
              }}
            >
              <Outlet />
            </Box>
            <Starter
              show={showStarter}
              width={starterWidth}
              onClose={() => { startupHelp_(false); setShowStarter(false) }}
            />
            {showStarter === false && (
              <CollapseVertical
                label="Startup"
                color="grey"
                onClick={() => { startupHelp_(true); setShowStarter(true) }}
              />
            )}
          </Box>
        </div>
      </LocalizationProvider>
    </div>
  );
};

// const Profile = () => {
//   console.log("go to my profile");
//   return <div className="App"></div>;
// };

// const HmmErrorBoundary = () => {
//   // let error = useRouteError();
//   // console.error(error);
//   // Uncaught ReferenceError: path is not defined
//   return <div>Hmm! That shouldn't have happened. Please return to the login page and sign in again.</div>;
// }

const App = () => {
  const [clientJson, setClientJson] = useState({
    public: false,
    shared: false,
    readonly: false,
    uuid: empty_uuid,
    s_uuid: empty_uuid,
    name: "",
    spouseName: "",
    Scenario: {
      uuid: empty_uuid,
      label: "",
      readonly: false,
      executed: "",
    },
    Sweep: {
      uuid: empty_uuid,
      label: "",
    },
  });

  // const history = createBrowserHistory();

  // useEffect(() => {
  //   const filterParams = history.location.search.substr(1);
  //   const filtersFromParams = qs.parse(filterParams);
  //   if (filtersFromParams.client) {
  //     setClientJson(decodeURI(JSON.parse(filtersFromParams.client)));
  //   }
  // }, []);

  // useEffect(() => {
  //   if (clientJson) {
  //     history.push(`?client=${encodeURI(JSON.stringify(clientJson))}`);
  //   }
  // }, [clientJson]);
  const useDocumentTitle = (title) => {
    useEffect(() => {
      document.title = title;
    }, [title]);
  };
  useDocumentTitle("MyOwnFP");

  useEffect(() => {
    if (window.localStorage.getItem("client")) {
      try {
        setClientJson(JSON.parse(window.localStorage.getItem("client")));
        console.log("got loccal client");
        console.log(JSON.parse(window.localStorage.getItem("client")));
      } catch {
        window.localStorage.removeItem("client");
        console.log("removed bad client");
      }
    } else {
      console.log("no client");
    }
  }, []);

  useEffect(() => {
    if (clientJson) {
      window.localStorage.setItem("client", JSON.stringify(clientJson));
      console.log("stored client");
      console.log(clientJson);
    }
  }, [clientJson]);

  const clientCallback = (c_json) => {
    console.log("ccback " + c_json);
    let nf = { ...c_json };
    if (nf.Name !== clientJson.Name) {
      let bc = [
        <Link underline="hover" key="1" href="/scenarioSelect">
          {nf.Name}
        </Link>,
      ];
      nf = { ...nf, Breadcrumbs: bc };
    }
    setClientJson(nf);
    console.log(nf);
  };


  // const ErrorBoundaryLayout = () => (
  //   <ErrorBoundary FallbackComponent={GlobalError}>
  //     <Outlet />
  //   </ErrorBoundary>
  // );

  const boundaryMsg = "Ugh! That shouldn't have happened. We tracked this and will fix it soon. Please return to the login page and sign in again."

  const ErrorDisplay = ({ error, resetError }) => (// <-- props passed to fallbackUI component
    <div>{boundaryMsg}</div>
  );
  const ErrorDisplay1 = ({ error, resetError }) => ( // <-- props passed to fallbackUI component
    <div>{boundaryMsg}</div>
  );

  // const ErrorDisplayC = () => {
  //   return (
  //     <div>
  //       {boundaryMsg}
  //     </div>
  //   )
  // }


  // const MyErrorBoundary = ({ context = "", children }) => {
  //   return (
  //     <ErrorBoundary key={context} level={LEVEL_ERROR} fallbackUI={ErrorDisplay1}>
  //       {/* <RollbarContext context={context}> */}
  //       {children}
  //       {/* </RollbarContext> */}
  //     </ErrorBoundary>
  //   )
  // }
  // <ErrorBoundary errorMessage="Error in React render" fallbackUI={ErrorDisplay} />



  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<AuthLayout />} // this will render instead of `element`
      // errorElement={<MyErrorBoundary />}
      >
        <Route element={<ProtectedLayout />}
        // errorElement={<MyErrorBoundary />}
        >
          <Route
            path="/"
            element={
              <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                <TopLayout clientJson={clientJson} c_callback={clientCallback} />
              </ErrorBoundary>
            }
          // errorElement={<MyErrorBoundary />}
          >
            <Route
              path="gridScenario"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <GridScenarioViewPort
                    //key={uuidv4()} // this was needed to make sure we re-autosize the contents, but in 32.0.0 its fixed
                    clientJson={clientJson}
                    c_callback={clientCallback}
                    uuids={[{ uuid: clientJson.Scenario.uuid, label: clientJson.Scenario.label }]}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="sweep"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <Sweep clientJson={clientJson}
                    c_callback={clientCallback} />
                </ErrorBoundary>
              }
            />
            <Route
              path="scenarioCharts"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <ScenarioCharts clientJson={clientJson} />
                </ErrorBoundary>
              }
            />
            <Route
              path="subscriberSelect"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <SubscriberSelect />
                </ErrorBoundary>
              }
            />
            <Route
              path="clientSelect"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <ClientSelect
                    clientJson={clientJson}
                    c_callback={clientCallback}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="scenarioSelect"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <ScenarioSelect
                    clientJson={clientJson}
                    c_callback={clientCallback}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="setupAccounts"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <SetupAccounts
                    clientJson={clientJson}
                    c_callback={clientCallback}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="setupSavingRules"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <SetupSavingRules
                    clientJson={clientJson}
                    c_callback={clientCallback}
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="ideaboard"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <SuggestionBoard title="Suggestion Board" name="Suggestion" board="f11864d6-e7c7-42c2-aa30-6e603de34bc8"
                    extraNewText="<br/>This board is mainly for new features.<br/><br/>If you think you have found a bug, please email support@myownfp.ca.<br/> You can send screen captures (or png or csv) of input or output to make that easier to diagnose.<br/><br/>If you can't figure something out or where something is, please email support@myownfp.ca.<br/>"
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="newsboard"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <NewsBoard board="20a8217b-c08a-4104-93d2-305401d158a2"
                  />
                </ErrorBoundary>
              }
            />
            <Route
              path="profile"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <ProfileInput open={true} />
                </ErrorBoundary>
              }
            />
            <Route
              path="help"
              element={
                <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
                  <Help_selectClient open={true} />
                </ErrorBoundary>
              }
            />
          </Route>
        </Route>
        <Route
          path="signin"
          element={
            <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay1}>
              <SignIn />
            </ErrorBoundary>
          }
        />
      </Route >
    ),
    {
      future: {
        v7_relativeSplatPath: true,
      }
    },
  );





  return (

    <Provider config={rollbarConfig}>
      <ErrorBoundary errorMessage="Error in React render" fallbackUI={ErrorDisplay}>
        <ThemeProvider theme={theme}>
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </ThemeProvider>
      </ErrorBoundary>
    </Provider >
  );
};


export default App;
